import { render, staticRenderFns } from "./StatisticsPeriodReport.vue?vue&type=template&id=2cb8bf02&"
import script from "./StatisticsPeriodReport.vue?vue&type=script&lang=js&"
export * from "./StatisticsPeriodReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports